
import { Component, Prop, Vue } from 'vue-property-decorator';
import { VResponsive } from 'vuetify/lib';

@Component({
  // explicitly import VResponsive so it works with dynamic component
  components: { VResponsive },
  inheritAttrs: false,
})
export default class VideoPlayerMinimal extends Vue {
  @Prop({ type: String, default: 'div' })
  readonly tag!: string;
  @Prop(Number)
  readonly aspectRatio?: number;
  @Prop(Boolean)
  readonly fullScreen?: boolean;
  @Prop(Boolean)
  readonly showExpandButton?: boolean;
  @Prop(Boolean)
  readonly showMuteButton?: boolean;
  @Prop(Boolean)
  readonly showPlayButton?: boolean;
  @Prop(String)
  readonly title?: string;

  isMuted = true;
  isPaused = true;
  isExpanded = false;

  mounted() {
    // default isMuted state should respect muted attr
    this.isMuted = !!(this.$attrs.muted === '' || this.$attrs.muted);
  }

  get hasCustomControls() {
    return this.showMuteButton || this.showPlayButton;
  }

  onPlay() {
    this.isPaused = false;
  }

  onPause() {
    this.isPaused = true;
  }

  toggleMute() {
    this.isMuted = !this.isMuted;
  }

  handleExpand() {
    this.isExpanded = true;
  }

  handlePlay() {
    const video = this.$refs.video as HTMLVideoElement;
    return this.isPaused ? video?.play() : video?.pause();
  }
}
